import { observe, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, withRouter } from 'react-router-dom';
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { EInput } from 'src/Components/EInput';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { TestsStore } from 'src/Stores/Tests/TestsStore';
import { IEBPExpenseType, IInventoryEBP, ITest } from '../../../../../Interfaces/TestInterface';
import { IWell } from '../../../../../Interfaces/WellInterface';
import DataTable from '../../../../DataTable';
import Footer from '../../../../Footer';
import WorkflowHeader from '../../../WorkflowHeader';
import TotalHeader from '../TotalHeader';

interface IList {
    headers: any[];
    rows: any[];
}

@inject('stores')
@observer
class EBP extends React.Component {
    public props: any;
    private expenseList: IEBPExpenseType[] = [];
    private modalDataSet: IList;
    private dataSet: IList;
    private test: ITest = new ITest();
    public TestsStore: TestsStore;
    private testDisposer: any;
    private well: IWell = new IWell();
    public WellsStore: any;
    private wellDisposer: any;
    private MessageStore: MessageStore;

    public state = {
        dataSet: this.dataSet,
        expenseList: this.expenseList,
        expenseListMaster: this.expenseList,
        isDirty: false,
        modal: false,
        modalDataSet: this.modalDataSet,
        modalDataSetMaster: this.modalDataSet,
        newInventoryList: [] as boolean[],
        newInventoryListMaster: [] as boolean[],
        saveClicked: false,
        showMasterItems: false,
        sortOrder: 1,
        test: this.test,
        well: this.well,
    };

    constructor(props: any) {
        super(props);

        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;
        this.MessageStore = this.props.stores.MessageStore;

        this.toggleModal = this.toggleModal.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleMultiSelect = this.handleMultiSelect.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleRecurringCheckboxChange = this.handleRecurringCheckboxChange.bind(this);


        this.clearDisposers = this.clearDisposers.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    public componentDidMount() {

        if ( this.props.stores.WellsStore.well && this.props.stores.TestsStore.test ) {
            const test = toJS(this.TestsStore.test);
            this.allCalculations(test);
            this.setState({
                test,
                well: toJS(this.WellsStore.well)
            }, () => {
                this.formatDataTable();
            });
        } else {
            if ( ! this.TestsStore.test ) {
                this.TestsStore.getTestDetails(this.props.match.params.taskId, this.props.match.params.wellId);
            }
            if ( ! this.WellsStore.well ) {
                this.WellsStore.getWellDetails(this.props.match.params.wellId);
            }
        }
        this.createDisposers();
        this.getExpenseTypes().then(() => {
            this.getMasterExpenseList();
        });
    }

    public createDisposers() {
        this.testDisposer = observe(this.TestsStore, 'test', (change: any) => {
            const test = toJS(change.newValue);
            this.allCalculations(test);
            this.setState({
                test,
            }, () => {
                this.formatDataTable();
            });
        });

        this.wellDisposer = observe(this.WellsStore, 'well', (change: any) => {
            const well = toJS(change.newValue);
            this.setState({
                well
            });
        });
    }

    private renderUnit = (row: IInventoryEBP, index: number) => (tabIndex: number) => {
        return (
            <EInput
                name="unit"
                id="unit"
                value={row.unit}
                data-validation="integer"
                onChange={this.handleInputChange(index)}
                disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                tabIndex={tabIndex+10}
            />
        );
    }

    private renderQuantity = (row: IInventoryEBP, index: number) => (tabIndex: number) => {
        return (
            <EInput
                type="text"
                name="quantity"
                id="quantity"
                data-validation="integer"
                value={row.quantity}
                onChange={this.handleInputChange(index)}
                disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                tabIndex={tabIndex+10}
            />
        );
    }

    private renderUnitPrice = (row: IInventoryEBP, index: number) => (tabIndex: number) => {
        return (
        <EInput
            type="text"
            name="unitPrice"
            id="unitPrice"
            data-min={0}
            data-mask="currency"
            data-validation="decimal"
            value={row.unitPrice}
            onChange={this.handleInputChange(index)}
            disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
            tabIndex={tabIndex+10}
        />
        );
    }

    private renderTotalCost = (row: IInventoryEBP, index: number) => (tabIndex: number) => {
        return (
            <EInput
                type="text"
                name="totalCost"
                id="totalCost"
                data-mask="currency"
                value={row.totalCost}
                disabled={true}
            />
        );
    }

    private renderRecurring = (row: IInventoryEBP, index: number) => (tabIndex: number) => {
        return (
            <FormGroup check={true} className="align-center">
                <Label>
                    <Input
                        type="checkbox"
                        name="isRecurring"
                        id={"isRecurring" + index}
                        checked={row.isRecurring}
                        onChange={this.handleRecurringCheckboxChange(index)}
                        disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                        tabIndex={tabIndex+10}
                    />
                </Label>
            </FormGroup>
        );
    }

    private renderReference = (row: IInventoryEBP, index: number) => (tabIndex: number) => {
        return (
        <EInput
            name="referenceNumber"
            id="referenceNumber"
            value={row.referenceNumber}
            onChange={this.handleInputChange(index)}
            disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
            tabIndex={tabIndex+10}
        />
        );
    }

    private renderReallocation = (row: IInventoryEBP, index: number) => (tabIndex: number) => {
        const testList = this.TestsStore.tests;
        let currTestIndex = -1;
        let isDisabled = false;
        if (testList !== undefined) {
            if (testList.length === 1) {
                isDisabled = true;
            } else {
                currTestIndex = testList.findIndex(test => test.id === this.state.test.id);
            }
        }


        if (currTestIndex >= 0) {
            const prevTest = testList[currTestIndex + 1];
            if (prevTest && prevTest.fluidType === this.state.test.mudProperties.fluidType && !this.state.test.isNewIntervalReport) {
                isDisabled = true;
            }
        }
        
        return (
        <EInput
            type="text"
            name="reallocation"
            id="reallocation"
            data-max={Number(row.unit) * row.quantity}
            data-validation="integer"
            value={row.reallocation}
            onChange={this.handleInputChange(index)}
            disabled={!this.state.test.isInventoryReport || isDisabled}
            tabIndex={tabIndex+10}
        />
        );
    }

    private handleReorder = (startIndex: any, endIndex: any) => {
        const test = this.state.test;
        const result = test.ebpInventorys.sort((a,b) => a.defaultSortOrdinal - b.defaultSortOrdinal);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        result.forEach((val, index) => {
            val.defaultSortOrdinal = index;
        });
        this.setState({
            isDirty: true,
            test
        }, () => {
            this.formatDataTable();
        });
    }

    private changeDefaultSort = (indexes: number[], defaultSortName: string) => {
        const test = this.state.test;
        const result = test.ebpInventorys;
        result.forEach((val, index) => {
            val[defaultSortName] = indexes[index];
        });

        this.setState({
            isDirty: true,
            test
        }, () => {
            this.formatDataTable();
            this.MessageStore.addMessage("Your custom sort order has been set. Please save the page to save the custom sort order you set.", 'success', 3000);
        });
    }


    private formatDataTable() {
        const headers = [
            'Expense',
            'Type',
            'Frequency',
            'Units',
            'Price',
            'Total',
            'Recurring',
            'Ref No',
            'Reallocate to Previous'
        ];

        const rows = this.state.test.ebpInventorys.map((row, index) => 
            [
                {
                    content: row.expenseType.name,
                },
                {
                    content: row.expenseType.isRental ? "Rental" : "Service"
                },
                {
                    content: this.renderUnit(row, index),
                    sortItem: row.unit,
                    type: 'render',
                },
                {
                    content: this.renderQuantity(row, index),
                    sortItem: row.quantity,
                    type: 'render',
                },
                {
                    content: this.renderUnitPrice(row, index),
                    sortItem: row.unitPrice,
                    type: 'render',
                },
                {
                    content: this.renderTotalCost(row, index),
                    sortItem: row.totalCost,
                    type: 'render',
                },
                {
                    content: this.renderRecurring(row, index),
                    sortItem: row.isRecurring,
                    type: 'render',
                },
                {
                    content: this.renderReference(row, index),
                    sortItem: row.referenceNumber,
                    type: 'render',
                },
                {
                    content: this.renderReallocation(row, index),
                    sortItem: row.reallocation,
                    type: 'render'
                },
                {
                    sortItem: row.defaultSortOrdinal,
                    type: 'defaultSort'
                }
            ]
        );

        this.setState({
            dataSet: {
                headers,
                rows,
            }
        });
    }

    private formatModalDataTable() {
        const newDataList: any[] = [];
        const newDataListMaster: any[] = [];
        const tableHeaders = [
            'EBP Item',
            'Service Type',
            'Price'
        ];
        if ( this.state.expenseList ) {
            this.state.expenseList.map((expense: IEBPExpenseType, index: number) => {
                const newObject = [
                    {
                        content: expense.name,
                    },
                    {
                        content: expense.isRental ? "Rental" : "Service",
                    },
                    {
                        content: expense.retailPrice
                    }
                ];
                newDataList.push(newObject);
            });
        }

        if ( this.state.expenseListMaster ) {
            this.state.expenseListMaster.map((expense: IEBPExpenseType, index: number) => {
                const newObject = [
                    {
                        content: expense.name,
                    },
                    {
                        content: expense.isRental ? "Rental" : "Service",
                    },
                    {
                        content: expense.retailPrice
                    }
                ];
                newDataListMaster.push(newObject);
            });
        }
        const listStructure = {
            headers: tableHeaders,
            rows: newDataList
        };

        const listStructureMaster = {
            headers: tableHeaders,
            rows: newDataListMaster,
        };

        this.setState({
            modalDataSet: listStructure,
            modalDataSetMaster: listStructureMaster,
        });
    }

    public async componentWillUnmount() {
        this.clearDisposers();
    }

    public clearDisposers() {
        if ( this.testDisposer ) {
            this.testDisposer();
        }
        if ( this.wellDisposer ) {
            this.wellDisposer();
        }
    }

    private getExpenseTypes() {
        return this.TestsStore.getExpenseTypes(this.props.match.params.wellId)
        .then(
            (data: any) => {
                this.setState({
                    expenseList: data
                }, () => {
                    this.formatModalDataTable();
                });
            }
        );
    }

    private getMasterExpenseList() {
        this.TestsStore.getExpenseTypes()
            .then(expenseMasterList => {
                if (expenseMasterList) {
                    const expenseListMaster = expenseMasterList.filter((expense: IEBPExpenseType) => 
                        !this.state.expenseList.some(p => p.id === expense.id)
                    );
                    this.setState({expenseListMaster}, () => {
                        this.formatModalDataTable();
                    });
                }
            });
    }
    
    private handleListToggle = () => {
        this.setState({
            showMasterItems: !this.state.showMasterItems,
        });
    }

    private toggleModal() {
        if ( this.state.modal ) {
            this.setState({
                newInventoryList: []
            });
        } else {
            this.getExpenseTypes();
            this.setState({
                showMasterItem: false,
            });
        }
        this.setState({
            modal: !this.state.modal
        }, () => {
            this.formatModalDataTable();
        });
    }

    private handleSave() {
        const test = this.state.test;
        const ebpInventorys = test.ebpInventorys;
        this.state.expenseList.map((expenseType: IEBPExpenseType, index: number) => {
            if (this.state.newInventoryList[index]) {
                const newInventoryExpense = new IInventoryEBP();
                newInventoryExpense.expenseType = expenseType;
                newInventoryExpense.isTaxable = expenseType.isTaxable;
                newInventoryExpense.unitPrice = expenseType.retailPrice;
                ebpInventorys.push(newInventoryExpense);
            }
        });

        this.state.expenseListMaster.map((expenseType: IEBPExpenseType, index: number) => {
            if (this.state.newInventoryListMaster[index]) {
                const newInventoryExpense = new IInventoryEBP();
                newInventoryExpense.expenseType = expenseType;
                newInventoryExpense.isTaxable = expenseType.isTaxable;
                newInventoryExpense.unitPrice = expenseType.retailPrice;
                ebpInventorys.push(newInventoryExpense);
            }
        });

        
        test.ebpInventorys = ebpInventorys;
        this.allCalculations(test);
        this.setState({
            isDirty: true,
            test
        }, () => {
            this.formatDataTable();
        });

        this.toggleModal();
    }

    private handleMultiSelect(index: number) {
        if (this.state.showMasterItems) {
            const newInventoryListMaster = this.state.newInventoryListMaster;
            newInventoryListMaster[index] = !newInventoryListMaster[index];
            this.setState({newInventoryListMaster});    
        } else {
            const newInventoryList = this.state.newInventoryList;
            newInventoryList[index] = !newInventoryList[index];
            this.setState({newInventoryList});
        }
    }

    private handleDelete = (index: number) => {
        const test = this.state.test;
        const ebpInventorys = this.state.test.ebpInventorys;
        const expenseList = this.state.expenseList;
        expenseList.push(ebpInventorys[index].expenseType);
        ebpInventorys.splice(index, 1);
        test.ebpInventorys = ebpInventorys;
        this.setState({
            expenseList,
            isDirty: true,
            test
        }, () => {
            this.formatDataTable();
            this.allCalculations();
        });
    }

    public handleInputChange = (index: any) => (event: any) => {
        const test = this.state.test;
        const row = this.state.test.ebpInventorys[index];

        row[event.target.name] = event.target.value;
        test.ebpInventorys[index] = row;
        this.allCalculations(test);
        this.setState({
            isDirty: true,
            test
        });
    }

    public handleRecurringCheckboxChange = (index: any) => (event: any) => {
        event.persist();
        const test = this.state.test;
        const row = this.state.test.ebpInventorys[index];

        if ( event.target.type === 'checkbox' ) {
            row.isRecurring = !row.isRecurring;

            if ( !row.isRecurring ) {
                event.target.removeAttribute('checked');
            } else {
                event.target.setAttribute('checked', 'checked');
            }
        } else {
            row[event.target.name] = event.target.value;
            test.ebpInventorys[index] = row;
        }

        this.setState({
            isDirty: true,
            test
        });
    }

    public allCalculations(currTest?: ITest) {
        const test = currTest ? currTest : this.state.test;
        if (test.ebpInventorys) {
            test.ebpInventorys.forEach(row => {

                const unitPrice: any = row.unitPrice.toString().replace(/[$,]/g, '');
                
                row.totalCost = row.quantity * unitPrice * Number(row.unit);
            });
        }

        if (!currTest) {
            this.setState({
                test
            });
        }
    }

    private updateTestModel = () => {
        this.TestsStore.updateTestModel(this.state.test, this.props.match.params.wellId).then((test:any) => {
            if (test) {
                this.setState({
                    isDirty: false,
                });
            }
        });
    }

    private buttonNavigation = (event: any) => {
        const $target = event.target;
        if ( $target.name === 'previous' ) {
            this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/inventory/products');
        } else {
            if (this.props.workflowHeaderItems[1].some((w: string) => w === 'Dispatches')) {
                this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/inventory/dispatches');
            } else {
                this.props.history.push('/well/' + this.props.match.params.wellId + '/test/' + this.props.match.params.taskId + '/inventory/volumeaccounting');
            }
        }
    }

    public handleChange(test: ITest) {
        this.setState({
            isDirty: true,
            test
        });
    }

    public sortColumnHeader(columnName: string, event:any) {
        event.persist();
        const table: any = document.getElementById('sortableTable');
        let sortOrder = this.state.sortOrder;
        const data = this.state.test;

        //
        // This goes through and adds/removes classes based on sorting
        // This will help identify which column is sorted and in what order
        if ( table !== null ) {
            const tbody: any = table.getElementsByTagName('tbody')[0];
            const wasAsc:boolean = event.target.classList.contains('asc');
            const wasPreviouslySorted: boolean = event.target.classList.contains('asc', 'desc');
            const ths: any = table.getElementsByTagName('th');
            const tds: any = tbody.getElementsByTagName('td');
            
            if ( !wasPreviouslySorted ) {
                sortOrder = 1;
                this.setState({
                    sortOrder: 1
                });
            }

            for ( const th of ths ) {
                th.classList.remove('asc', 'desc');
            }

            for ( const td of tds ) {
                td.classList.remove('sorted');
            }

            for ( const row of tbody.rows ) {
                row.cells[event.target.cellIndex].classList.add('sorted');
            }

            if ( wasAsc ) {
                event.target.classList.add('desc');
            } else {
                event.target.classList.add('asc');
            }

        }

        if (data) {
            const sortedData = data.ebpInventorys.sort((a: IInventoryEBP, b:IInventoryEBP) => {
                if (columnName === 'name') {
                    return a.expenseType.name.localeCompare(b.expenseType.name) * sortOrder;
                } 
                
                if (columnName === 'isRental') {
                    return (a.expenseType.isRental === b.expenseType.isRental ? 0 : a.expenseType.isRental ? -1 : 1) * sortOrder;
                }

                if (typeof a[columnName] === 'string' && isNaN(Number(a[columnName]))) {
                    return a[columnName].localeCompare(b[columnName]) * sortOrder;
                } else if (typeof a[columnName] === 'number' || !isNaN(Number(a[columnName]))) {
                    return (Number(a[columnName]) - Number(b[columnName])) * sortOrder;
                } else if (typeof a[columnName] === 'boolean') {
                    return (a[columnName] === b[columnName] ? 0 : a[columnName] ? -1 : 1) * sortOrder;
                } else {
                    return 0;
                }
            });
            data.ebpInventorys = sortedData;
            this.setState({
                sortOrder: sortOrder * -1,
                test: data,
            });
        }
    }

    public render() {
        const enableEBP = this.state.test.isInventoryReport && this.state.test.testStatus !== 'Approved';
        return(
            <div className="EBP">
            <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} isInventoryReport={this.state.test.isInventoryReport}/>
                <Row>
                    <Col md="12">
                        <TotalHeader handleChange={this.handleChange} test={this.state.test} well={this.state.well}/>
                    </Col>
                    <Col md="12">
                        <DataTable
                            onNew={enableEBP ? {
                                callback: this.toggleModal,
                                text: 'Add EBP',
                            } : undefined}
                            list={this.state.dataSet}
                            onDelete={enableEBP ? this.handleDelete : undefined}
                            onReorder={enableEBP ? this.handleReorder : undefined}
                            defaultSort={{
                                change: enableEBP ? this.changeDefaultSort : undefined,
                                index: 9,
                                name: 'defaultSortOrdinal'
                            }}
                            varWidths={true}
                        />
                        {/* <div className="data-table-component">
                            <div className="scroll-wrapper">
                                <ValidatedForm validated={this.state.test.ebpInventorys}>
                                    <Table id="sortableTable" className="sortableTable">
                                        <thead>
                                            <tr>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "name")}>Expense</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "isRental")}>Type</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "unit")}>Frequency</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "quantity")}>Units</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "unitPrice")}>Price</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "totalCost")}>Total</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "isRecurring")}>Recurring</th>
                                                <th className="sortable" onClick={this.sortColumnHeader.bind(this, "referenceNumber")}>Ref No</th>
                                                {this.state.test.isInventoryReport && this.state.test.testStatus !== 'Approved' &&
                                                    <th>&nbsp;</th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { this.state.test.ebpInventorys &&
                                                this.state.test.ebpInventorys.map((row: IInventoryEBP, index: number) =>
                                                    <tr key={index}>
                                                        <td>{row.expenseType.name}</td>
                                                        <td>{row.expenseType.isRental ? "Rental" : "Service"}</td>
                                                        <td>
                                                            <EInput
                                                                name="unit"
                                                                id="unit"
                                                                value={row.unit}
                                                                data-validation="integer"
                                                                onChange={this.handleInputChange(index)}
                                                                disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                                                                tabIndex={(index+1)+10}
                                                            />
                                                        </td>
                                                        <td>
                                                            <EInput
                                                                type="text"
                                                                name="quantity"
                                                                id="quantity"
                                                                data-validation="integer"
                                                                value={row.quantity}
                                                                onChange={this.handleInputChange(index)}
                                                                disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                                                                tabIndex={(index+1)+10+this.state.test.ebpInventorys.length}
                                                            />
                                                        </td>
                                                        <td>
                                                            <EInput
                                                                type="text"
                                                                name="unitPrice"
                                                                id="unitPrice"
                                                                data-min={0}
                                                                data-mask="currency"
                                                                data-validation="decimal"
                                                                value={row.unitPrice}
                                                                onChange={this.handleInputChange(index)}
                                                                disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                                                                tabIndex={(index+1)+10+this.state.test.ebpInventorys.length*2}
                                                            />
                                                        </td>
                                                        <td>
                                                            <EInput
                                                                type="text"
                                                                name="totalCost"
                                                                id="totalCost"
                                                                data-mask="currency"
                                                                value={row.totalCost}
                                                                disabled={true}
                                                            />
                                                        </td>
                                                        <td className="align-center">
                                                            <FormGroup>
                                                                <Label>
                                                                    <Input
                                                                        type="checkbox"
                                                                        name="isRecurring"
                                                                        id={"isRecurring" + index}
                                                                        checked={row.isRecurring}
                                                                        onChange={this.handleRecurringCheckboxChange(index)}
                                                                        disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                                                                        tabIndex={(index+1)+10+this.state.test.ebpInventorys.length*3}
                                                                    />
                                                                </Label>
                                                            </FormGroup>
                                                        </td>
                                                        <td>
                                                            <EInput
                                                                name="referenceNumber"
                                                                id="referenceNumber"
                                                                value={row.referenceNumber}
                                                                onChange={this.handleInputChange(index)}
                                                                disabled={!this.state.test.isInventoryReport || this.state.test.testStatus === 'Approved'}
                                                                tabIndex={(index+1)+10+this.state.test.ebpInventorys.length*4}
                                                            />
                                                        </td>
                                                        {this.state.test.isInventoryReport && this.state.test.testStatus !== 'Approved' &&
                                                            <td>
                                                                <div className="remove-row" onClick={this.handleDelete.bind(this, index)}>
                                                                    <FontAwesomeIcon icon={['far', 'trash-alt']}/>
                                                                </div>
                                                            </td>
                                                        }
                                                    </tr>
                                                ) }
                                        </tbody>
                                    </Table>
                                </ValidatedForm>
                            </div>
                            {this.state.test.isInventoryReport && this.state.test.testStatus !== 'Approved' &&
                                <div className="add-table-row">
                                    <Button color="primary" className="add-new-button" onClick={this.toggleModal}>
                                        <FontAwesomeIcon icon="plus" />
                                        { ' Add EBP' }
                                    </Button>
                                </div>
                            }
                        </div> */}
                    </Col>
                </Row>
                <Footer 
                    well={this.WellsStore.well}
                    test={this.TestsStore.test}
                    onSave={this.updateTestModel}
                    onNavigate={this.buttonNavigation}
                    saveDisabled={!(this.state.test.isInventoryReport && this.state.test.testStatus !== 'Approved')}
                />
                <Modal isOpen={this.state.modal} fade={false} toggle={this.toggleModal} style={{'maxWidth': 'fit-content'}}>
                    <ModalHeader toggle={this.toggleModal}>EBP List</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md="12">
                                <DataTable
                                    list={this.state.showMasterItems ? this.state.modalDataSetMaster : this.state.modalDataSet}
                                    onMultiSelect={this.handleMultiSelect}
                                    multiSelectChecked={this.state.showMasterItems ? this.state.newInventoryListMaster : this.state.newInventoryList}
                                />
                            </Col>
                        </Row>
                        <div className="add-table-row">
                            <Button color={this.state.showMasterItems ? 'outline-primary' : 'primary'} onClick={this.handleListToggle}>{this.state.showMasterItems ? 'View Regional EBP Items' : 'View Non-Regional EBP Items'}</Button>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" name="previous" onClick={this.toggleModal}>Cancel</Button>
                        <Button color="primary" name="save" onClick={this.handleSave}>Add</Button>                        
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default withRouter(EBP);



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/Inventory/EBP/EBP.tsx